import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import ProgramDetail from "@/pages/ProgramDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Refund from "@/pages/Refund";
import AnnouncementBar from "@/components/AnnouncementBar";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import RouteTracker from "@/components/RouteTracker";
import AnalyticsTracker from "@/components/AnalyticsTracker";

const SPLASH_FADE_MS = 600;

function App() {
  // Hide the inline splash screen once React mounts
  useEffect(() => {
    const splash = document.getElementById("initial-splash");
    if (!splash) return;
    splash.classList.add("fade-out");
    const timer = setTimeout(() => splash.remove(), SPLASH_FADE_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <HelmetProvider>
      <div className="App bg-sand-100 text-ink">
        <BrowserRouter>
          <RouteTracker />
          <AnalyticsTracker />
          <AnnouncementBar />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/programs/:slug" element={<ProgramDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/refund" element={<Refund />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
